module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_fluctuation_02.19984266.png";